import { createApp } from 'vue'
import store from '@/store/index'
import App from './App.vue'
import AppForbidden from './AppForbidden.vue'
import CKEditor from '@ckeditor/ckeditor5-vue'
import Datepicker from '@vuepic/vue-datepicker'
import router from '@/router'
import { TnBridgeService } from '@/services/TnBridgeService'
import { AuthService } from '@/services/AuthService'
import VueYandexMetrika from 'vue-v3-yandex-metrika'
import eruda from 'eruda'

import '@vuepic/vue-datepicker/dist/main.css'
import './assets/main.css'
import './assets/css/include-fonts.css'

const tnBridgeService = new TnBridgeService()
const authService = new AuthService()

if ((window as any).VUE_APP_ERUDA == 'true') {
  eruda.init()
}

if ((window as any).VUE_APP_API_MODE != 'local') {
  // Получаем код авторизации
  tnBridgeService.init().then(() => {
    tnBridgeService.getAuthCode().then((response: any) => {
      // Пробуем авторизоваться
      authService
        .authorize({
          authCode: response.data.code,
        })
        .then(
          () => {
            if ((window as any).VUE_APP_YANDEX_ID) {
              createApp(App)
                .use(router)
                .use(store)
                .use(CKEditor)
                .use(VueYandexMetrika, {
                  id: (window as any).VUE_APP_YANDEX_ID,
                  router: router,
                  env: (window as any).VUE_APP_YANDEX_ENV,
                })
                .component('Datepick', Datepicker)
                .mount('#app')
            } else {
              createApp(App)
                .use(router)
                .use(store)
                .use(CKEditor)
                .component('Datepick', Datepicker)
                .mount('#app')
            }
          },
          (err) => {
            console.log('ERR', err)

            createApp(AppForbidden).mount('#app')
          }
        )
    })
  })
} else {
  console.log('LOCAL')
  authService
    .authorize({
      authCode: '',
    })
    .then(
      (resp) => {
        console.log('local', resp)

        if ((window as any).VUE_APP_YANDEX_ID) {
          createApp(App)
            .use(router)
            .use(store)
            .use(CKEditor)
            .use(VueYandexMetrika, {
              id: (window as any).VUE_APP_YANDEX_ID,
              router: router,
              env: (window as any).VUE_APP_YANDEX_ENV,
            })
            .component('Datepick', Datepicker)
            .mount('#app')
        } else {
          createApp(App)
            .use(router)
            .use(store)
            .use(CKEditor)
            .component('Datepick', Datepicker)
            .mount('#app')
        }
      },
      (err) => {
        console.log('ERR', err)
        createApp(AppForbidden).mount('#app')
      }
    )
    .catch((err) => console.log('local', err))
}
export const handleRefreshToken = () => {
  authService
    .refreshToken()
    .then((res) => {
      console.log('Token refreshed', res)
    })
    .catch((err) => console.log('Error while refreshing token', err))
}

export const handleLinkRedirect = (link) => {
  if (!/^https?:\/\//i.test(link)) {
    link = 'http://' + link
  }
  tnBridgeService
    .goToLink(link)
    .then((res) => {
      console.log('Link function success', res)
    })
    .catch((err) => {
      console.log('Link function failed', err)
    })
}
